import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Navbar from './Navbar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Skeleton from '@mui/material/Skeleton';
import Button from '@mui/material/Button';
import ConnectionFinder from '../api/ConnectionFinder';

const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: '20px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.grey[300]}`,
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    '&:hover': {
        transform: 'translateY(-10px)',
        boxShadow: '0 20px 40px -15px rgba(255, 15, 100, 0.25)',
    },
    '& .MuiCardMedia-root': {
        transition: 'transform 0.4s ease-in-out',
    },
    '&:hover .MuiCardMedia-root': {
        transform: 'scale(1.05)',
    },
}));

const PostsList = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        ConnectionFinder.get('/posts')
            .then(res => {
                setPosts(res.data.data || []);
                setLoading(false);
            })
            .catch(err => {
                console.error("Errore recupero post:", err);
                setLoading(false);
            });
    }, []);

    return (
        <div style={{ width: '100%', minHeight: 'calc(100vh - 202px)' }}>
            <Navbar />
            <Box 
                sx={{ 
                    background: 'linear-gradient(45deg, #ff0f64 30%, #b20756 90%)',
                    py: { xs: 8, md: 12 },
                    textAlign: 'center',
                    color: 'white'
                }}
            >
                <Container maxWidth="md">
                    <Typography component="h1" variant="h2" sx={{ fontWeight: '800', letterSpacing: '-1.5px', mb: 2 }}>
                        Il Nostro Blog
                    </Typography>
                    <Typography variant="h5" sx={{ color: 'rgba(255, 255, 255, 0.85)', maxWidth: '700px', mx: 'auto', fontWeight: 300 }}>
                        Notizie, guide e approfondimenti dal mondo della connettività. Rimani sempre aggiornato.
                    </Typography>
                </Container>
            </Box>
            <Box sx={{ backgroundColor: '#f9fafb', py: { xs: 4, sm: 6, md: 8 }, px: { xs: 2, sm: 4, md: 6 } }}>
                {loading ? (
                    <Grid container spacing={4} justifyContent="center">
                        {Array.from(new Array(6)).map((item, index) => (
                            <Grid item xs={12} sm={8} md={6} lg={4} key={index}>
                                <StyledCard>
                                    <Skeleton variant="rectangular" animation="wave" height={250} />
                                    <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 3 }}>
                                        <Skeleton animation="wave" height={15} width="40%" sx={{ mb: 1.5 }} />
                                        <Skeleton animation="wave" variant="text" sx={{ fontSize: '1.5rem', mb: 2 }} />
                                        <Skeleton animation="wave" variant="rectangular" height={80} sx={{ mb: 3, flexGrow: 1 }} />
                                        <Skeleton animation="wave" height={24} width="30%" />
                                    </CardContent>
                                </StyledCard>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <Grid container spacing={4} justifyContent="center">
                        {posts.map((post, index) => (
                            <Grid item xs={12} sm={8} md={6} lg={4} key={post.id}>
                                <StyledCard>
                                    {post.cover_image && (
                                        <CardMedia component="img" height="250" image={post.cover_image} alt={post.title} />
                                    )}
                                    <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 3 }}>
                                        <Typography variant="caption" sx={{ color: 'text.secondary', mb: 1.5, display: 'block' }}>
                                            {new Date(post.published_at || post.created_at).toLocaleDateString('it-IT', { year: 'numeric', month: 'long', day: 'numeric' })}
                                        </Typography>
                                        <Typography variant="h5" component="h2" sx={{ fontWeight: '700', mb: 2, flexGrow: 1 }}>
                                            <Link to={`/blog/${post.slug}`} style={{ textDecoration: 'none', color: 'inherit', '&:hover': { color: '#ff0f64' } }}>
                                                {post.title}
                                            </Link>
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, lineHeight: 1.7 }}>
                                            {post.excerpt}
                                        </Typography>
                                        <Box sx={{ mt: 'auto' }}>
                                            <Button component={Link} to={`/blog/${post.slug}`} variant="text" sx={{ color: '#ff0f64', fontWeight: 'bold', p: 0, '&:hover': { backgroundColor: 'transparent' } }}>
                                                Leggi l'articolo
                                            </Button>
                                        </Box>
                                    </CardContent>
                                </StyledCard>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Box>
        </div>
    );
};

export default PostsList;